/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.hzxm" placeholder="输入姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.hzsfzh" placeholder="输入患者身份证号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.isbr" placeholder="请选择是否本人">
          <el-option v-for="type in isbr" :label="type.key" :value="type.value" :key="type.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.youji" placeholder="请选择是否邮寄">
         <el-option value=""  key="请选择是否邮寄"></el-option>

          <el-option v-for="type in youji" :label="type.key" :value="type.value" :key="type.key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :header-cell-style="{background:'#00A0FF',color:'white',border: '1px solid tan'}" :row-class-name="tableRowClassName" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column align="center" prop="hzxm" label="患者姓名" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="hzsfzh" align="center" label="患者身份证号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="hzzyh" align="center" label="患者住院号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="fynr" align="center" label="复印内容" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="fyfs" align="center" label="复印份数" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="hzzyh" align="center" label="患者住院号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="isbr" align="center" label="是否本人" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ylt1" v-if="scope.row.isbr ==1">本人</div>
             <div class="ylt1" v-if="scope.row.isbr ==0" style="color: red;">代办</div>
           </template>
      </el-table-column>
      <el-table-column prop="dbrxm" align="center"  width="140" label="代办人姓名/手机号/身份证号" show-overflow-tooltip>
          <template slot-scope="scope">
              <div class="ylt1" >{{scope.row.dbrxm}}</div>
               <div class="ylt1" >{{scope.row.dbrtel}}</div>
              <div class="ylt1" >{{scope.row.dbrsfzh}}</div>
           </template>
      </el-table-column>

      <el-table-column prop="tel" align="center" label="代办人上传资料" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ylt" v-for="il in scope.row.zmt">
              <img :src="il" @click="yulandatu(il)">
            </div>

           </template>
      </el-table-column>

      <el-table-column prop="isbr" align="center" label="是否邮寄" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ylt1" v-if="scope.row.youji ==0">否</div>
             <div class="ylt1" v-if="scope.row.youji ==1" style="color: red;">邮寄</div>
           </template>
      </el-table-column>
      <el-table-column prop="sjrxm" align="center" label="收件人/电话" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ylt1" >{{scope.row.sjrxm}}</div>
             <div class="ylt1" >{{scope.row.sjrtel}}</div>
           </template>
      </el-table-column>
      <el-table-column prop="address" align="center" label="收件人地址" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ylt1" >{{scope.row.sfxz}}  {{scope.row.cityxz}}  {{scope.row.districtxz}}</div>
             <div class="ylt1" >{{scope.row.xxdz}}</div>
           </template>
      </el-table-column>
      <el-table-column prop="beizhu" align="center" label="备注" width="100" show-overflow-tooltip>
            </el-table-column>


      <el-table-column sortable prop="pay_price" align="center" label="支付金额（元）" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="price_sm" align="center" label="费用明细" width="100" show-overflow-tooltip>
      </el-table-column>

      <el-table-column sortable prop="status" align="center" label="审核状态" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-show="scope.row.status == '1'"><span style="color: green;">审核通过</span></div>
            <div v-show="scope.row.status == '0'"><span >待审核</span></div>
            <div v-show="scope.row.status == '2'"><span style="color: red;">审核未通过</span></div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="create_time" align="center" label="提交时间" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="160">
        <template slot-scope="scope">
            <el-button size="mini" type="danger"  @click="edit(scope.row)">编辑</el-button>
      </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


    <el-dialog title="订单信息" :visible.sync="refundVisible">
      <el-form :model="form">

        <el-form-item label="患者姓名">
          <el-input type="text"   readonly="" v-model="form.hzxm" class="binajiinput rbj" ></el-input>
        </el-form-item>
        </el-form-item>
        <el-form-item label="患者身份证号">
          <el-input type="text"  readonly=""  v-model="form.hzsfzh" class="binajiinput rbj"  ></el-input>
        </el-form-item>

        <el-form-item label="患者住院号">
          <el-input type="text" readonly v-model="form.hzzyh"  class="binajiinput"  ></el-input>
        </el-form-item>
        <el-form-item label="复印内容">
          <el-input type="text" readonly v-model="form.fynr"  class="binajiinput"  ></el-input>
        </el-form-item>
        <el-form-item label="复印份数">
          <el-input type="text" readonly v-model="form.fyfs"  class="binajiinput"  ></el-input>
        </el-form-item>
        <el-form-item label="审核状态" >
          <div class="binajiinput" >

            <el-radio v-model="radio" label=1 value="1" >通过</el-radio>
            <el-radio v-model="radio" label=2 value="2">未通过</el-radio>

          </div>
       </el-form-item>
       <el-form-item label="总费用">
         <el-input type="text" v-model="form.pay_price"  class="binajiinput"  ></el-input>
       </el-form-item>
      <el-form-item label="费用明细">
        <el-input type="text" v-model="form.price_sm"  class="binajiinput"  ></el-input>
      </el-form-item>
      <el-form-item label="审核说明">
        <el-input type="text" v-model="form.sh_sm"  class="binajiinput"  ></el-input>
      </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
         <el-button @click="refundVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitform">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="预览" :visible.sync="yulan">

      <div style="text-align: center;" class="ylt1">
          <img :src="imgUrl" >
      </div>



    </el-dialog>
  </div>
</template>

<script>
import { getZzkdOrder,updateZzkdOrder,getitem,balist,updateorder} from '../../api/baseset'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false,
      refundVisible: false,
      refund_passwd: '',
      refund_row: [],
      radio: 0,
      isbr:[
        { key: '是', value: 1 },
        { key: '否', value: 0 },

      ],
      youji:[
        { key: '是', value: 1 },
        { key: '否', value: 0 },

      ],
      payStatus: [
        { key: '请选择', value: 0 },
        { key: '支付成功', value: 'SUCCESS' },
         { key: '未支付', value: 'NOTPAY' },
        { key: '单边账', value: 'SUCCESSBUTHISERROR' },
        { key: '已退费', value: 'REFUND' }
      ],
      payType: [
        { key: '请选择', value: 0 },
        { key: '门诊挂号', value: '门诊挂号' },
        { key: '门诊缴费', value: '门诊缴费' },
        { key: '住院预交金', value: '住院预交金' }
      ],
      itemType:[],
      formInline: {
        page: 1,
        limit: 10,
        type:2
      },
      xuanzeradio:'',
      listData: [], //订单数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      formData:[],
      form: {
        doctorpic: '',
        doctorinfo: ''
      },
      yulan:false,
      orderqr:[
        {key:'未确认',value:'0'},
        {key:'确认',value:'1'},

      ],
      item:[],
      imgUrl:''
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getxmitem();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
        balist(parameter)
         .then(res => {
           console.log(res)
           this.loading = false
           if (res.success == false) {
             this.$message({
               type: 'info',
               message: res.msg
             })

           } else {
             this.listData = res.data
             // 分页赋值
             this.pageparm.currentPage = this.formInline.page
             this.pageparm.pageSize = this.formInline.limit
             this.pageparm.total = res.count
           }
         })
         .catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
    },
    getxmitem(){
      getitem()
        .then(res => {
            this.item =res.data
        })
        .catch(err => {

        })

    },
    // 重置搜索
    formReset() {
       this.formInline = {
        page: 1,
        limit: 10
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.formInline.limit = 10
      this.getdata(this.formInline)
    },
    // 编辑
    edit(row) {
      this.refund_row = row;
      this.refundVisible = true;
      this.form = row
      console.log(this.form)

      console.log(row.order_status)
      this.radio = row.status+ ""
      //this.radio = '1'
      console.log(this.radio)
    },

    autoOrder(row) {
      this.$confirm('确定要同步订单信息吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.loading = true
        const param = {id:row.id}
        orderToHis(param)
          .then(res => {
            this.loading = false
            this.$message({
              type: 'info',
              message: res.msg
            })
          })
          .catch(err => {
            this.loading = false
            this.$message.error('同步失败，请稍后再试！')
          })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消同步'
        })
      })
    },
    tableRowClassName({ row, rowIndex }) {
          if (rowIndex % 2 === 1) {
            return 'success-row' //这是类名
          } else  {
            return ''
          }
    },
    submitform(){
      var param = this.form;
      param.order_status = this.radio;
      if(this.radio == '0' ){
        this.$message.error('请选择审核状态')

        return ;
      }
      if(this.radio == 1){
        if(this.form.pay_price =='' || this.form.pay_price< 10){
          this.$message.error('请输入正确的费用金额')
          return ;
         }
        if(this.form.price_sm =='' ){
          this.$message.error('请输入费用的详细说明')
          return ;
         }
      }
      if(this.radio == 2){
        if(this.form.sh_sm =='' || this.form.sh_sm.length <10){
          this.$message.error('审核说明不能少于10个字')
          return ;
         }

      }
      var fybj ={id:this.form.id,status:this.radio,pay_price:this.form.pay_price,price_sm:this.form.price_sm,sh_sm:this.form.sh_sm}



     console.log(fybj);
     //return ;
      updateorder(fybj)
        .then(res => {
          this.loading = false
          this.$message({
            type: 'info',
            message: res.msg
          })
          this.refundVisible = false;
          this.getdata(this.formInline);
        })
        .catch(err => {
          this.loading = false
          this.$message.error('修改失败，请稍后再试！')
        })
    },
    yulandatu(url){
      console.log(url)
      this.imgUrl = url;
      this.yulan = true
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.binajiinput{
  width: 70%;
  float: right;
  margin-right: 10%;
}
.rbj{
  background-color: #666666;
}
.ylt img{
  width: 40px;
  height: 60px;
}
.ylt1 img{
  width: 100%;
  height: 100%;

}
</style>



// WEBPACK FOOTER //
// src/views/bafy/wtgbafylist.vue